import { ApiHelper } from '../../../helpers/apihelper'
import * as Constants from '../../../helpers/constants'

/* Data Pulse fair-usage stats data-access seam.
 *
 * Backend chain: cocrmwebapp -> sfcloud BFF (POST api/v1/{client}/data_pulse/fair_usage_stats,
 * added in cocloud2's Phase 13b) -> cocloud2 (GET /crm/data_pulse/fair_usage_stats, Phase 13a).
 * Response shape: { pool: {size, in_flight}, backlog: {count, oldest_created_on},
 * entities: {total_active_users, total_active_orgs, waiting_for_slot_count, top: [...]} }.
 * top entity rows are { id, type, in_flight, pending, min, max, providers } -- id only, no
 * resolved name (out of scope per 13a's own design decision; left for a later phase to resolve
 * if needed). providers is the distinct set of CRM providers (hubspot/salesforce) behind that
 * row's currently active requests -- usually one, but a user/org can have more than one active
 * integration at once.
 */
const isSuccess = (response) => response && response.status === Constants.CO_API.SUCCESS

const EMPTY_STATS = {
  pool: { size: 0, in_flight: 0 },
  backlog: { count: 0, oldest_created_on: null },
  entities: { total_active_users: 0, total_active_orgs: 0, waiting_for_slot_count: 0, top: [] }
}

export const fetchFairUsageStats = (client, { top_n } = {}, signal = null) => {
  return ApiHelper(client, 'DATA_PULSE_FAIR_USAGE_STATS').API(client, { top_n }, signal)
    .then((response) => (isSuccess(response) ? response.data : EMPTY_STATS))
}
